var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterTopArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 21.87 12.99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.12 0H8.79V4.33H13.12V0Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.45 4.33H13.12V8.66H17.45V4.33Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.87 8.66H17.54V12.99H21.87V8.66Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.75 4.33H4.42V8.66H8.75V4.33Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.33 8.66H0V12.99H4.33V8.66Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTopArrow);
export default __webpack_public_path__ + "static/media/footer-top-arrow.c2eda010e505cf544611b261176e2cd9.svg";
export { ForwardRef as ReactComponent };